<script>
  import ClubSelector from "./ClubSelector.svelte";
  import ShowDocument from "./ShowDocument.svelte";
  import PrivacyTermsAndConditions from "./PrivacyTermsAndConditions.svelte";
  import { _, locale, locales } from "svelte-i18n";
  import { localeLabels } from "../i18n";

  export let active;
  export let user;
  export let env;
  export let updateUser;
  export let showErrorMessage = false;
  export let coach = false;

  let showReportWithType = false;
  let inProgress = false;

  function close() {
    active = false;
    window.document.body.classList.toggle("modal-is-active");
    showErrorMessage = false;
    inProgress = false;
  }

  function save() {
    inProgress = true;
    updateUser(user)
      .then((success) => {
        window.document.body.classList.toggle("modal-is-active");
        inProgress = false;
      })
      .catch((error) => {
        inProgress = false;
        console.log("Not able to create user");
      });
  }
</script>

{#if active}
  <div class="modal">
    <div class="modal__backdrop" />
    <div class="modal__wrapper">
      <div
        class="modal__content"
        style="animation: 0s ease 0s 1 normal none running none;"
      >
        <div>
          <header class="modal__header">
            <button
              on:click={close}
              type="button"
              class="modal__button-close"
            />
            <h1 class="h2">
              {user.id !== undefined
                ? $_("profile.form.edit")
                : $_("profile.form.add")}
            </h1>
          </header>
          <div class="modal__body">
            <form>
              <fieldset class="form-section">
                <label for="lang" class="select"
                  ><h1 class="layout__title">{$_("profile.language")}</h1>
                  <span class="select__button" style="width: 200px;">
                    <select
                      style="width: 200px;"
                      on:change={(e) =>
                        localStorage.setItem("language", e.target.value)}
                      bind:value={$locale}
                    >
                      {#each $locales as locale}
                        <option value={locale}
                          >{localeLabels.find((item) => item.value === locale)
                            .label}</option
                        >
                      {/each}
                    </select>
                  </span>
                </label>
                <h3>{$_("profile.form.contactInfo")}</h3>
                <label for="name" class="input"
                  ><span class="input__label">{$_("profile.form.name")}</span
                  ><input
                    type="text"
                    name="name"
                    bind:value={user.name}
                    class="input__text"
                    id="name"
                  /></label
                ><label for="surname" class="input"
                  ><span class="input__label">{$_("profile.form.surname")}</span
                  ><input
                    type="text"
                    name="surname"
                    bind:value={user.surname}
                    class="input__text"
                    id="surname"
                  /></label
                >
                {#if false}
                  <label for="adress" class="input"
                    ><span class="input__label">Adresse</span><input
                      type="text"
                      name="address"
                      value=""
                      class="input__text"
                      id="adress"
                    /></label
                  ><label for="postCode" class="input"
                    ><span class="input__label">Postnummer</span><input
                      type="number"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      name="postCode"
                      value=""
                      class="input__text input__text--inline input__text--size-sm"
                      id="postCode"
                    />
                    <p class="input-label-after">(city)</p></label
                  >
                {/if}
                <label for="email" class="input"
                  ><span class="input__label">{$_("profile.form.email")}</span
                  ><input
                    type="email"
                    name="email"
                    bind:value={user.email}
                    disabled=""
                    class="input__text"
                    id="email"
                  /></label
                ><label for="tel" class="input"
                  ><span class="input__label">{$_("profile.form.phone")}</span>
                  <div
                    class="input__text input__text--size-md"
                    style="display:flex; flex-direction: row;"
                  >
                    <span style="padding: 0px; width: 10px; color: grey;"
                      >+</span
                    >
                    <input
                      style="padding: 0px; width: 25px; color: grey;"
                      type="countyCode"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      name="mobile"
                      on:change={(e) => (user.countryCode = e.target.value)}
                      value={user.countryCode || "47"}
                      id="countyCode"
                    />
                    <input
                      style="padding: 0px; width: 100%;"
                      type="tel"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      name="mobile"
                      bind:value={user.phone}
                      id="tel"
                    />
                  </div></label
                >
                <label for="birthDate" class="input"
                  ><span class="input__label"
                    >{$_("profile.form.dateOfBirth")}</span
                  ><input
                    type="date"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    name="date-of-birth"
                    bind:value={user.birthDate}
                    class="input__text"
                    id="birthDate"
                  /></label
                ><label for="sexId" class="select"
                  ><span class="select__label"
                    >{$_("profile.form.gender.title")}</span
                  ><span class="select__button"
                    ><select id="sexId" name="gender" bind:value={user.gender}
                      ><option value=""
                        >{$_("profile.form.gender.select")}</option
                      ><option value="female"
                        >{$_("profile.form.gender.woman")}</option
                      ><option value="male"
                        >{$_("profile.form.gender.man")}</option
                      ></select
                    ></span
                  ></label
                >
              </fieldset>
              {#if false}
                <fieldset class="form-section">
                  <h3>Søkbarhet</h3>
                  <label class="checkbox" for="searchable"
                    ><input
                      type="checkbox"
                      class="checkbox__input-hidden"
                      id="searchable"
                      name="searchable"
                      value="searchable-on"
                    /><span class="checkbox__input-custom" /><span
                      class="checkbox__label"
                      >Mitt navn skal ikke være søkbart for andre brukere av
                      treningsdagboken.</span
                    ></label
                  >
                </fieldset>
              {/if}
              {#if coach}
                <fieldset class="form-section">
                  <h3>{$_("profile.form.trainer.title")}</h3>
                  <label class="checkbox" for="coachClub"
                    ><input
                      type="checkbox"
                      class="checkbox__input-hidden"
                      id="coachClub"
                      name="coachClub"
                      bind:checked={user.coachClub}
                    /><span class="checkbox__input-custom" /><span
                      class="checkbox__label"
                      >{$_("profile.form.trainer.club")}</span
                    ></label
                  >
                  <label class="checkbox" for="coachFederation"
                    ><input
                      type="checkbox"
                      class="checkbox__input-hidden"
                      id="coachFederation"
                      name="coachFederation"
                      bind:checked={user.coachFederation}
                    /><span class="checkbox__input-custom" /><span
                      class="checkbox__label"
                      >{$_("profile.form.trainer.national")}</span
                    ></label
                  >
                </fieldset>
              {/if}
              <fieldset class="form-section">
                <label for="sports" class="select"
                  ><span class="select__label">{$_("profile.sport")}</span><span
                    class="select__button"
                    ><select id="sports" disabled="disabled"
                      ><option value="xx">Kunstløp</option></select
                    ></span
                  ></label
                ><label for="federation" class="select"
                  ><span class="select__label"
                    >{$_("profile.form.federation")}</span
                  ><span class="select__button"
                    ><select id="federation" disabled="disabled"
                      ><option value="4FB4F6C8-BD66-4B10-83EA-38E07283E650"
                        >Norges Skøyteforbund</option
                      ></select
                    ></span
                  ></label
                >
                <ClubSelector bind:user />
                <label class="input" for="Skole"
                  ><span class="input__label">{$_("profile.form.school")}</span>
                  <div style="display: block;">
                    <input
                      class="input__text"
                      role="combobox"
                      aria-autocomplete="list"
                      aria-expanded="false"
                      autocomplete="off"
                      bind:value={user.school}
                      id="Skole"
                    />
                  </div></label
                >
              </fieldset>
              {#if !user.consent && !env?.includes("no_gdpr")}
                <PrivacyTermsAndConditions
                  bind:user
                  bind:showReportWithType
                  {showErrorMessage}
                />
              {/if}
              {#if false}
                <fieldset class="form-section">
                  <h3>Treningsinnstillinger</h3>
                  <p class="input__label">Mine pulssoner</p>
                  <div class="izones">
                    <div class="izones__inputs">
                      <div class="izones__item izones__item--pulse">
                        <span
                          class="izones__label izones__label--i1-three-izones"
                          >i1</span
                        ><label class="izones__label-pulse" for="pulse-i1-1"
                          ><input
                            type="number"
                            max="999"
                            class="izones__number"
                            maxlength="3"
                            name="pulse-i1-1"
                            id="pulse-i1-1"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value=""
                          /></label
                        ><label class="izones__label-pulse" for="pulse-i1-2"
                          ><input
                            type="number"
                            max="999"
                            class="izones__number"
                            maxlength="3"
                            name="pulse-i1-2"
                            id="pulse-i1-2"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value=""
                          /></label
                        >
                      </div>
                      <div class="izones__item izones__item--pulse">
                        <span
                          class="izones__label izones__label--i2-three-izones"
                          >i2</span
                        ><label class="izones__label-pulse" for="pulse-i2-1"
                          ><input
                            type="number"
                            max="999"
                            class="izones__number"
                            maxlength="3"
                            name="pulse-i2-1"
                            id="pulse-i2-1"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value=""
                          /></label
                        ><label class="izones__label-pulse" for="pulse-i2-2"
                          ><input
                            type="number"
                            max="999"
                            class="izones__number"
                            maxlength="3"
                            name="pulse-i2-2"
                            id="pulse-i2-2"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value=""
                          /></label
                        >
                      </div>
                      <div class="izones__item izones__item--pulse">
                        <span
                          class="izones__label izones__label--i3-three-izones"
                          >i3</span
                        ><label class="izones__label-pulse" for="pulse-i3-1"
                          ><input
                            type="number"
                            max="999"
                            class="izones__number"
                            maxlength="3"
                            name="pulse-i3-1"
                            id="pulse-i3-1"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value=""
                          /></label
                        ><label class="izones__label-pulse" for="pulse-i3-2"
                          ><input
                            type="number"
                            max="999"
                            class="izones__number"
                            maxlength="3"
                            name="pulse-i3-2"
                            id="pulse-i3-2"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value=""
                          /></label
                        >
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="form-section">
                  <h3>Dagboksinnstillinger</h3>
                  <div>
                    <span class="input__label">Planlegging av trening</span>
                    <div class="radio-group">
                      <div class="radio-group">
                        <label class="radio" for="planning-mode-per-måned"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            name="planning-mode"
                            id="planning-mode-per-måned"
                            value="0"
                          /><span class="radio__input-custom" /><span
                            class="radio__label">per måned</span
                          ></label
                        ><label class="radio" for="planning-mode-per-uke"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            name="planning-mode"
                            id="planning-mode-per-uke"
                            value="1"
                          /><span class="radio__input-custom" /><span
                            class="radio__label">per uke</span
                          ></label
                        >
                      </div>
                    </div>
                  </div>
                  <label class="checkbox" for="comment-notification"
                    ><input
                      type="checkbox"
                      class="checkbox__input-hidden"
                      id="comment-notification"
                      name="comment-notification"
                      value="notification-on"
                    /><span class="checkbox__input-custom" /><span
                      class="checkbox__label"
                      >Varsle trener om kommentarer på økter (kan endres per
                      økt)</span
                    ></label
                  ><label class="checkbox" for="show-tips"
                    ><input
                      type="checkbox"
                      class="checkbox__input-hidden"
                      id="show-tips"
                      name="show-tips"
                      value="tips-on"
                    /><span class="checkbox__input-custom" /><span
                      class="checkbox__label"
                      >Vis tips for bruk av dagboken</span
                    ></label
                  >
                </fieldset>
              {/if}
              <fieldset class="form-section form-section--submit">
                <p class="warning">
                  {$_("profile.form.warning")}
                </p>
                <div class="layout-buttons layout-buttons--left-right">
                  {#if user.id !== undefined}
                    <button
                      on:click={close}
                      type="button"
                      class="button-text button-text--cancel"
                      >{$_("generic.buttons.cancel")}</button
                    >
                  {/if}
                  <button
                    on:click={save}
                    type="button"
                    disabled={inProgress}
                    class="button button--icon {user.id !== undefined
                      ? 'button--icon-check'
                      : 'button--icon-link'} {inProgress
                      ? 'button--disabled'
                      : ''}"
                    >{user.id !== undefined
                      ? $_("generic.buttons.save")
                      : $_("profile.form.submit")}</button
                  >
                </div>
              </fieldset>
            </form>
          </div>
          {#if showErrorMessage}
            <span class="form-error is-visible">{$_("profile.form.error")}</span
            >
          {/if}
        </div>
      </div>
    </div>
  </div>
{/if}
{#if showReportWithType}
  <ShowDocument
    active={showReportWithType}
    onClose={() => (showReportWithType = false)}
    documentType={showReportWithType}
  />
{/if}
